import {
  Dashboard,
  People,
  Assessment,
  Settings,
  AccountCircle,
  Summarize,
  LockReset,
  Bookmark,
  Assignment,
  Tune,
  Groups,
  SwitchAccount,
  ViewList,
  PlayArrow,
  HourglassBottom,
  AssignmentTurnedIn,
  Stop,
  Security,
  Troubleshoot,
  Outbox,
  Analytics,
  Insights,
  SatelliteAlt,
  Schedule,
  TravelExplore,
  WifiTetheringError,
  PictureAsPdf,
  AssignmentInd,
  FactCheck,
} from '@mui/icons-material';
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  chat: getIcon('ic_chat'),
  user: getIcon('ic_user'),
  dashboard: <Dashboard />,
  insurance: getIcon('ic_insurance'),
  userList: <People />,
  tradeList: <Assessment />,
  activityLogs: <Assignment />,
  settings: <Settings />,
  reports: <Summarize />,
  weekelyReports: <PictureAsPdf />,
  riskReport: <Troubleshoot />,
  profile: <AccountCircle />,
  watchlist: <Bookmark />,
  equityLotSettings: <Tune />,
  generalSettings: <Settings />,
  executedTrades: <AssignmentTurnedIn />,
  pendingTrades: <HourglassBottom />,
  changePassword: <LockReset />,
  lineTrades: <Security />,
  tradeAnalysis: <Analytics />,
  clientUsers: <Groups />,
  brokerUsers: <SwitchAccount />,
  positions: <ViewList />,
  activeTrades: <PlayArrow />,
  closedTrades: <Stop />,
  broadcast: <Outbox />,
  filterTradesIcon: <Tune />,
  customFiltersIcon: <FactCheck />,
  suspiciousTicksIcon: <TravelExplore />,
  tradeAnalysisIcon: <Insights />,
  deltaAnalyzerIcon: <SatelliteAlt />,
  deltaAlertTradesIcon: <WifiTetheringError />,
  ledgerReports: <AssignmentInd />,
  scriptsTiming: <Schedule />,
};

const adminNavConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    // subheader: 'management',
    items: [
      { title: 'dashboard', path: PATH_DASHBOARD.insurerRole.brokerlist.root, icon: ICONS.dashboard },
      { title: 'watchlist', path: PATH_DASHBOARD.insurerRole.watchlist.root, icon: ICONS.watchlist },
      { title: 'activity logs', path: PATH_DASHBOARD.insurerRole.log.root, icon: ICONS.activityLogs },
      // { title: 'Trade Analysis', path: PATH_DASHBOARD.insurerRole.tradeAnalysis.root, icon: ICONS.tradeAnalysis },
      { title: 'Brokers', path: PATH_DASHBOARD.insurerRole.broker.root, icon: ICONS.brokerUsers },
      { title: 'Clients', path: PATH_DASHBOARD.insurerRole.client.root, icon: ICONS.clientUsers },

      {
        title: 'Positions',
        icon: ICONS.positions,
        path: PATH_DASHBOARD.insurerRole.positions.grouped.root,
        children: [
          { title: 'Active', path: PATH_DASHBOARD.insurerRole.positions.grouped.active, icon: ICONS.activeTrades },
          { title: 'Closed', path: PATH_DASHBOARD.insurerRole.positions.grouped.closed, icon: ICONS.closedTrades },
        ],
      },
      {
        title: 'trades',
        icon: ICONS.tradeList,
        children: [
          { title: 'Executed', path: PATH_DASHBOARD.insurerRole.trades.executed, icon: ICONS.executedTrades },
          { title: 'Pending', path: PATH_DASHBOARD.insurerRole.trades.pending, icon: ICONS.pendingTrades },
        ],
      },
      {
        title: 'Delta Analyzer',
        icon: ICONS.deltaAnalyzerIcon,
        children: [
          {
            title: 'Delta Alert Trades',
            path: PATH_DASHBOARD.insurerRole.deltaAnalyzer.deltaAlertTrades,
            icon: ICONS.deltaAlertTradesIcon,
          },
          {
            title: 'Trade Analysis',
            path: PATH_DASHBOARD.insurerRole.deltaAnalyzer.tradeAnalysis,
            icon: ICONS.tradeAnalysisIcon,
          },
          {
            title: 'Custom Filters',
            path: PATH_DASHBOARD.insurerRole.deltaAnalyzer.customFilters,
            icon: ICONS.customFiltersIcon,
          },
          {
            title: 'Filter Trades',
            path: PATH_DASHBOARD.insurerRole.deltaAnalyzer.filterTrades,
            icon: ICONS.filterTradesIcon,
          },
          {
            title: 'Suspicious Ticks',
            path: PATH_DASHBOARD.insurerRole.deltaAnalyzer.suspiciousTicks,
            icon: ICONS.suspiciousTicksIcon,
          },
        ],
      },
      {
        title: 'Reports',
        icon: ICONS.reports,
        children: [
          {
            title: 'Weekly Reports',
            path: PATH_DASHBOARD.insurerRole.report.weekly,
            icon: ICONS.weekelyReports,
          },
          {
            title: 'Ledger Reports',
            path: PATH_DASHBOARD.insurerRole.report.clientLedger,
            icon: ICONS.ledgerReports,
          },
          {
            title: 'Risk Report',
            path: PATH_DASHBOARD.insurerRole.report.riskyUser,
            icon: ICONS.riskReport,
          },
          {
            title: 'Scripts Timing',
            path: PATH_DASHBOARD.insurerRole.report.scriptsTiming,
            icon: ICONS.scriptsTiming,
          },
          // { title: 'General settings', path: PATH_DASHBOARD.insurerRole.setting.general, icon: ICONS.generalSettings },
        ],
      },
      { title: 'Message BroadCast', path: PATH_DASHBOARD.insurerRole.messageBroadCast.root, icon: ICONS.broadcast },
      {
        title: 'settings',
        icon: ICONS.settings,
        children: [
          {
            title: 'Equity Lot Settings',
            path: PATH_DASHBOARD.insurerRole.setting.equity,
            icon: ICONS.equityLotSettings,
          },
          {
            title: 'Change Password',
            path: PATH_DASHBOARD.insurerRole.setting.changePassword,
            icon: ICONS.changePassword,
          },
          // { title: 'General settings', path: PATH_DASHBOARD.insurerRole.setting.general, icon: ICONS.generalSettings },
        ],
      },
    ],
  },
  // {// { title: 'profile', path: PATH_DASHBOARD.insurerRole.profile.root, icon: ICONS.profile },
  //   subheader: 'accounts',
  //   items: [
  //     { title: 'watchlist', path: PATH_DASHBOARD.insurerRole.watchlist.root, icon: ICONS.watchlist },
  //   ],
  // },
];

export default adminNavConfig;
